<template>

  <b-card
    v-if="data"
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Financial Summary</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          md="3"
          sm="4"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-success"
              >
                <feather-icon
                  size="24"
                  icon="TrendingUpIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button
                class="font-weight-bolder mb-0"
              >
                {{ new Intl.NumberFormat().format(data.netCollection) }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Net Collection
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="3"
          sm="4"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-info"
              >
                <feather-icon
                  size="24"
                  icon="TrendingUpIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button
                class="font-weight-bolder mb-0"
              >
                {{ new Intl.NumberFormat().format(data.totalCollection) }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Total Collection
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="3"
          sm="4"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-warning"
              >
                <feather-icon
                  size="24"
                  icon="TrendingUpIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button
                class="font-weight-bolder mb-0"
              >
                {{ new Intl.NumberFormat().format(data.commissionFee) }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Commission Fee
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside,
  BAvatar, BMediaBody, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BButton,
  },
  props: {
    data: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      statisticsItems2: [
        {
          icon: 'TrendingUpIcon',
          color: 'light-success',
          title: '230k',
          subtitle: 'Today Paid',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-success',
          title: '8.549k',
          subtitle: 'This Week Paid',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-success',
          title: '1.423k',
          subtitle: 'This month Paid',
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-danger',
          title: '$9745',
          subtitle: 'Today Refund',
          customClass: '',
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-info',
          title: '230k',
          subtitle: 'Today Total',
          customClass: 'mb-2 mb-xl-0',
        },
      ],
    }
  },
  created() {
    console.log(this.data)
  },
}
</script>
